import { CalendarSettingsScreen } from '@mrrmlab/feature-day-planner';

export function EinstellungenKalenderRoute() {
  return <CalendarSettingsScreen />;
}
